import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { LoginComponent } from './login/login.component';
import { PaydoneComponent } from './paydone/paydone.component';
import { PayGuard } from './pay.guard';
import { IndexComponent } from './index/index.component';
import { ChooseComponent } from './choose/choose.component';
import { SecondPackComponent } from './second-pack/second-pack.component';
import { SecondpaydoneComponent } from './secondpaydone/secondpaydone.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ComicPackComponent } from './cosmic pack/components/comcic-pack/comic-pack.component';
import { ComicPackPayDoneComponent } from './cosmic pack/components/comic-pack-pay-done/comic-pack-pay-done.component';
import { GalaDuoComponent } from './Gala Duo/gala-duo/gala-duo.component';
import { GalaDuoPayDoneComponent } from './Gala Duo/gala-duo-payDone/gala-duo-pay-done/gala-duo-pay-done.component';
import { MajorisComponent } from './Majoris/majoris/majoris.component';
import { MagorisPayDoneComponent } from './Majoris/majoris-payDone/magoris-pay-done/magoris-pay-done.component'
import { SultanaPackComponent } from './sultana-pack/sultana-pack.component';
import { SultanaPayDoneComponent } from './sultana-pay-done/sultana-pay-done.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'login/register', component: RegisterComponent },
  { path: 'login/forgot-password', component: ForgotPasswordComponent },
  { path: 'index', component: IndexComponent, canActivate: [AuthGuard] },
  { path: 'paydone', component: PaydoneComponent, canActivate: [PayGuard] },
  { path: 'choose', component: ChooseComponent, canActivate: [AuthGuard] },
  { path: 'secondPack', component: SecondPackComponent, canActivate: [AuthGuard] },
  { path: 'cosmicPack', component: ComicPackComponent, canActivate: [AuthGuard] },
  { path: 'secondPayDone', component: SecondpaydoneComponent, canActivate: [PayGuard] },
  { path: 'cosmicPackPayDone', component: ComicPackPayDoneComponent, canActivate: [PayGuard] },
  { path: 'gala-duo', component: GalaDuoComponent, canActivate: [AuthGuard] },
  { path: 'galaDuoPayDone', component: GalaDuoPayDoneComponent, canActivate: [PayGuard] },
  { path: 'majoris', component: MajorisComponent, canActivate: [AuthGuard] },
  { path: 'majorisPayDone', component: MagorisPayDoneComponent, canActivate: [PayGuard] },
  { path: 'sultana', component: SultanaPackComponent, canActivate: [AuthGuard] },
  { path: 'sultanaPayDone', component: SultanaPayDoneComponent, canActivate: [PayGuard] }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
